import React from "react";

function Up() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button 
      onClick={scrollToTop} 
      style={{
        position: "fixed",
        bottom: "92px",
        right: "24px",
        backgroundColor: "rgba(0,123,255,0.5)",
        
        color: "white",
        border: "none",
        borderRadius: "50%",
        width: "50px",
        height: "50px",
        fontSize: "24px",
        cursor: "pointer",
        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)"
      }}
      title="Volver arriba"
    >
      ▲
    </button>
  );
}

export default Up;
